import { Flex, Text } from '@chakra-ui/react';
import { Button } from '@diamond/shared/ui';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';

interface VoucherHeaderProps {
  title: string;
  onAdd?: () => void;
  showAction?: boolean;
}

export function VoucherHeader({
  title,
  onAdd,
  showAction = true,
}: VoucherHeaderProps) {
  const navigate = useNavigate();

  const handleAddClick = () => {
    if (onAdd) {
      onAdd();
    } else {
      navigate('/vouchers/new');
    }
  };

  return (
    <Flex justifyContent="space-between" alignItems="center" py={2}>
      <Text fontSize="2xl" fontWeight="bold" mb="0" color="gray.800">
        {title}
      </Text>

      {showAction && (
        <Button
          leftIcon={<AddIcon />}
          variant="solid"
          height="44px"
          px={6}
          onClick={handleAddClick}
        >
          Voucher Baru
        </Button>
      )}
    </Flex>
  );
}
